module.exports = __webpack_public_path__ + "img/1.8167c56f.svg";